import React from 'react';

import Link from '@material-ui/core/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { config } from '../../shared/config';

const styles = {
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'inline-flex',
        alignItems: 'center'
    }
};

export class BundleLink extends React.Component {
    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        return (
            <Link href={`${config.pos}/pos/bundle/${this.props.bundleNumber}`} onClick={this.stopPropagation} rel="noopener" style={styles.links} target="_blank">
                {this.props.bundleNumber}
                <OpenInNewIcon style={styles.icons} />
            </Link>
        )
    }
}
